import { useI18n } from '../i18n/i18n';
import { createNewDataSection, filterConditionalEntries } from '../utils/data-sections';
import { getTechnicalDataItemsModel } from '../utils/get-technical-data-items';
import useMarketConfig from '../store/market-config';
import useTranslations from '../store/translations';
export function useModelTechnicalDataSection(td) {
    var _a, _b;
    const { i18n } = useI18n();
    const { marketConfig } = useMarketConfig();
    const { translations } = useTranslations();
    const driveTrain = (_b = (_a = td === null || td === void 0 ? void 0 : td.modelAttributes) === null || _a === void 0 ? void 0 : _a.driveTrain) !== null && _b !== void 0 ? _b : 'BEV';
    if (!td) {
        return [];
    }
    const { engineData, performanceData, technicalData, drivelineData, landingGearData, brakeSystemData, steeringSystemData, weightsData, trailerWeightData, volumeData, consumptionData, noiseData, insuranceData, emissionData, } = getTechnicalDataItemsModel(td, (marketConfig === null || marketConfig === void 0 ? void 0 : marketConfig.market) || '', driveTrain, i18n, translations);
    return filterConditionalEntries([
        engineData &&
            createNewDataSection(i18n('compareLayer.technicalData.engine'), 'engineData', [engineData], translations),
        performanceData &&
            createNewDataSection(i18n('compareLayer.technicalData.performanceData'), 'performanceData', performanceData, translations),
        technicalData &&
            createNewDataSection(driveTrain === 'ICE' || driveTrain === 'MHEV'
                ? i18n('compareLayer.technicalData.combustionDrive')
                : i18n('compareLayer.technicalData.electricDrive'), 'technicalData', technicalData, translations),
        drivelineData &&
            createNewDataSection(i18n('compareLayer.technicalData.driveline'), 'drivelineData', drivelineData, translations),
        landingGearData &&
            createNewDataSection(i18n('compareLayer.technicalData.landingGear'), 'landingGearData', landingGearData, translations),
        brakeSystemData &&
            createNewDataSection(i18n('compareLayer.technicalData.brakeSystem'), 'brakeSystemData', brakeSystemData, translations),
        steeringSystemData &&
            createNewDataSection(i18n('compareLayer.technicalData.steeringSystem'), 'steeringSystemData', steeringSystemData, translations),
        weightsData &&
            createNewDataSection(i18n('compareLayer.technicalData.weights'), 'weightsData', weightsData, translations),
        (marketConfig === null || marketConfig === void 0 ? void 0 : marketConfig.market) !== 'TW' &&
            trailerWeightData &&
            createNewDataSection(i18n('compareLayer.technicalData.trailerWeightLimit'), 'trailerWeightData', trailerWeightData, translations),
        volumeData &&
            createNewDataSection(i18n('compareLayer.technicalData.volumes'), 'volumeData', volumeData, translations),
        consumptionData &&
            createNewDataSection(i18n('compareLayer.technicalData.consumption'), 'consumptionData', consumptionData, translations),
        noiseData &&
            createNewDataSection(i18n('compareLayer.technicalData.noiseLevel'), 'noiseData', noiseData, translations),
        insuranceData &&
            createNewDataSection(i18n('compareLayer.technicalData.insuranceClasses'), 'insuranceData', insuranceData, translations),
        emissionData &&
            createNewDataSection(i18n('compareLayer.technicalData.consumptionAndEmission'), 'emissionData', emissionData, translations),
    ]).filter((section) => section.entries.length > 0);
}
